export default __webpack_public_path__ + "assets/images/90e881dd62efe577be9dc14b2b66d8fb.png";